<script setup>
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const props = defineProps({
  branch: Object,
  name: String,
  isMobileView: Boolean
});

console.log('Branch props:', props);


</script>

<template>
    <div class="workfile-branch">
        <hr class="separator-mobile" v-if="isMobileView"/>
        <div class="workfile-branch-title">
            <span class="subtitle">{{ t('field.branch') }}</span>
        </div>
        <div class="workfile-branch-content">
            <div class="workfile-branch-content-item name" v-if="props.branch">
                <span>{{ props.name }}</span>
            </div>
            <div class="workfile-branch-content-item" v-if="props.branch">
                <span>{{ props.branch.address }}</span>
            </div>
            <div class="workfile-branch-content-item" v-if="props.branch">
                <span>{{ props.branch.city }}</span>
            </div>
            <div class="workfile-branch-content-item" v-if="props.branch">
                <span>{{ props.branch.state  + ' ' + props.branch.postal_code }}</span>
            </div>
            <div class="workfile-branch-content-item" v-if="props.branch">
                <span>{{ props.branch.phone }}</span>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.workfile-branch{
  @media only screen and (max-width: 1279px) {
    padding-left: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .subtitle{
    font-family: 'CircularStd-Bold';
    color: #153440;
    opacity: 0.42;
    font-size: 14px;
  }
  .workfile-branch-content{
    font-size: 12px;
    color: #000000;
  }
  .workfile-branch-content-item{
    font: normal normal normal 14px/19px 'CircularStd-Book';
    letter-spacing: 0px;
    color: #000000;
  }
  .bold{
    font-weight: bold;
  }
  .name{
    font-family: 'CircularStd-Bold';
    font-size: 14px;
  }
}
@media (max-width:576px) {
    .workfile-branch-content{
      margin-top: 0px;
      .workfile-branch-content-item.name{
      font-size: 18px !important;
      }
    }
    .workfile-branch-title {
       display: none;
      }
      .workfile-branch-content-item {
        font-size: 15px !important;
        font-family: 'CircularStd-Book';
        line-height: 1.3 !important;
      }
  }

@media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
    .workfile-branch-title {
      span.subtitle {
      font-family: 'CircularStd-Bold';
      font-size: 21px; 
    }
  }
  .workfile-branch-content {
    .workfile-branch-content-item.name{
      font-family: 'CircularStd-Bold';
    }
    .workfile-branch-content-item {
      font-size: 18px;
      font-family: 'CircularStd-Book';
    }
  }
}
.separator-mobile{
    margin-top: 20px;
    color: inherit;
    border: 0;
    border-top: 1px solid;
    opacity: 0.25;
    margin-bottom: 20px;
    justify-self:center;
    width: calc(100% + 40px); 
    margin-left: -20px; 
    margin-right: -20px;    
}

@media (min-width: 577px) and (max-width: 1280px) and (orientation: portrait) {
    .workfile-branch-title {
      span.subtitle {
      font-family: 'CircularStd-Bold';
      font-size: 18px; 
    }
    
  }
  .workfile-branch-content {
    .workfile-branch-content-item.name{
      font-family: 'CircularStd-Bold';
    }
    .workfile-branch-content-item {
      font-size: 18px;
      font-family: 'CircularStd-Book';
    }
  }
  .workfile-branch-content-item{
        span{
          font-size: 16px;
        } 
      }
}
</style>